import { FadeIn, SectionHeader } from "./Reveal";

const STEPS = [
    { title: "Kontakt", desc: "Zadzwoń lub wypełnij formularz. Odpowiadamy w ciągu 24 godzin." },
    { title: "Darmowa wycena", desc: "Przyjeżdżamy, oglądamy zakres prac i przygotowujemy uczciwą, niezobowiązującą wycenę." },
    { title: "Termin realizacji", desc: "Ustalamy dogodny termin i jasny harmonogram — bez niespodzianek." },
    { title: "Wykonanie", desc: "Realizujemy zlecenie solidnie, z dbałością o detale i porządek na miejscu pracy." },
    { title: "Odbiór prac", desc: "Wspólnie odbieramy efekt końcowy. Na wykonane usługi udzielamy gwarancji." },
];

export default function Timeline() {
    return (
        <section id="proces" className="bg-white py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <SectionHeader index="05" eyebrow="Jak wygląda współpraca" title="Pięć kroków do gotowego domu." className="mb-16" />
                <div className="relative ml-4 max-w-3xl md:ml-8">
                    <span className="absolute bottom-4 left-0 top-4 w-px bg-ink/10" aria-hidden />
                    {STEPS.map((s, i) => (
                        <FadeIn key={s.title} delay={i * 0.08}>
                            <div data-testid={`timeline-step-${i + 1}`} className="group relative flex gap-8 pb-14 last:pb-0">
                                <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-ink/10 bg-white font-mono text-sm font-bold text-ink shadow-sm transition-[background-color,border-color,color,transform] duration-500 group-hover:scale-110 group-hover:border-gold group-hover:bg-gold">
                                    {i + 1}
                                </span>
                                <div className="pt-1.5">
                                    <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{s.title}</h3>
                                    <p className="mt-2 max-w-lg text-sm leading-relaxed text-ink/55 md:text-base">{s.desc}</p>
                                </div>
                            </div>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
